import { useState, useEffect } from 'react'
import { doc, getDoc } from 'firebase/firestore'
import { db } from '../firebase'

// Custom hook to fetch organization type name
export const useOrganizationTypeName = (organizationId) => {
  const [typeName, setTypeName] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!organizationId) {
      setLoading(false)
      return
    }

    const fetchOrganizationType = async () => {
      try {
        // First get the organization document
        const orgDocRef = doc(db, 'organizations', organizationId.toString())
        const orgDocSnap = await getDoc(orgDocRef)

        if (orgDocSnap.exists()) {
          const orgData = orgDocSnap.data()

          // Check if organization has a type ID
          if (orgData.defaultUserTypeId) {
            // Fetch the user type document to get the name
            const userTypeDocRef = doc(
              db,
              'userTypes',
              orgData.defaultUserTypeId.toString()
            )
            const userTypeDocSnap = await getDoc(userTypeDocRef)

            if (userTypeDocSnap.exists()) {
              const userTypeData = userTypeDocSnap.data()
              setTypeName(userTypeData || 'Unknown Type')
            } else {
              setTypeName('Type not found')
            }
          } else {
            setTypeName('No type assigned')
          }
        } else {
          setTypeName('Organization not found')
        }
      } catch (error) {
        console.error('Error fetching organization type:', error)
        setTypeName('Error loading type')
      } finally {
        setLoading(false)
      }
    }

    fetchOrganizationType()
  }, [organizationId])

  return { typeName, loading }
}
